import { Box, Typography, Paper } from '@mui/material'

interface MedicationEducationProps {
    className?: string
}

export const MedicationEducation = ({
    className
}: MedicationEducationProps) => {
    return (
        <Box className={className}>
            <Paper
                elevation={0}
                sx={{ px: 0, mb: 2, bgcolor: 'background.default' }}
            >
                <Typography variant="h6" gutterBottom fontWeight="medium">
                    Semaglutide
                </Typography>

                <Typography variant="body1" paragraph>
                    Semaglutide acts on the GLP-1 receptor to help regulate
                    blood sugar and reduce appetite. It is clinically proven to
                    support blood sugar control and weight loss.
                </Typography>

                <Typography
                    variant="h6"
                    gutterBottom
                    fontWeight="medium"
                    sx={{ mt: 3 }}
                >
                    Tirzepatide
                </Typography>
                <Typography variant="body1" paragraph>
                    Tirzepatide is a dual agonist that activates both GLP-1 and
                    GIP receptors, which may lead to greater efficacy in blood
                    sugar control and weight loss. Some studies suggest
                    Tirzepatide may also be associated with fewer
                    gastrointestinal side effects. It is priced higher due to
                    its more complex formulation and increased manufacturing
                    costs.
                </Typography>

                <Typography
                    variant="h6"
                    gutterBottom
                    fontWeight="medium"
                    sx={{ mt: 3 }}
                >
                    Injectable vs Oral Medications
                </Typography>
                <Typography variant="body1">
                    Injectable GLP-1 medications are generally more effective
                    for weight loss and blood sugar control due to higher
                    bioavailability. Oral medications are a convenient option
                    but require strict dosing instructions and may offer less
                    potent results.
                </Typography>
            </Paper>
        </Box>
    )
}
